module.exports = __webpack_public_path__ + "img/804-f3b378.png";